import { useMediaQuery } from 'react-responsive';

const useOptimizePrimaryImage = (imageUrl: string, isNew: boolean): string => {
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1000 });
  const isMobile = useMediaQuery({ maxWidth: 767 });

  const widthParamTablet = isNew ? '?wid=1400' : '';
  const widthParamMobile = isNew ? '?wid=1000' : '';

  if (isTablet) return `${imageUrl}${widthParamTablet}`;

  if (isMobile) return `${imageUrl}${widthParamMobile}`;

  return imageUrl;
};

export default useOptimizePrimaryImage;
